import { useQuery } from "react-query";
import * as projectListService from "api/services/projectListService";

/**
 * Store server's state of all projects
 *
 * @returns {object} The query object return by the useQuery hook
 */
export const useProjectList = () =>
  useQuery(["projectList"], projectListService.getProjects, {
    select: (data) =>
      data.map((project) => ({
        ...project,
        description: [project.scopeOfWork, project.objectives]
          .filter(Boolean)
          .join(" "),
      })),
  });
